<template>
    <v-layout>
        <v-flex xs12 md6>
            <v-card flat>
                <v-sheet class="pa-3">
                    <!-- <v-text-field v-model="keyword" label="Search Issue" hide-details clearable></v-text-field> -->
                    <v-text-field v-model="inputKeyword" label="Search Issue" hide-details clearable></v-text-field>
                </v-sheet>
                <v-card-text class="treeview-container">
                    <v-treeview 
                        v-model="selectedIssues" 
                        :items="treeIssues" 
                        :search="keyword" 
                        item-text="title" 
                        item-children="treeChilds" 
                        activatable 
                        open-on-click 
                        selectable 
                        return-object 
                        active-class="grey lighten-4 indigo--text" 
                        selected-color="indigo" 
                        on-icon="bookmark" 
                        off-icon="bookmark_border" 
                        indeterminate-icon="bookmark">
                        <template slot="label" slot-scope="{ item }">
                            <template v-if="item.childrenCount">
                                {{ item.title }} <small>({{ item.childrenCount }})</small>
                            </template>
                            <template v-else>{{ item.title }}</template>
                        </template>
                    </v-treeview>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-divider vertical></v-divider>
        <v-flex xs12 md6>
            <v-card-text>
                <div v-if="selections.length === 0" key="title" class="title font-weight-light grey--text pa-3 text-xs-center">
                    Select issues
                </div>
                <v-scroll-x-transition group hide-on-leave>
                    <v-chip v-for="(selection, i) in selections" :key="i" color="grey" dark small>
                        <v-icon small class="mr-2">fas fa-tag</v-icon>
                        {{ selection.title.toUpperCase() }}
                    </v-chip>
                </v-scroll-x-transition>
            </v-card-text>
        </v-flex>
    </v-layout>
</template>

<script>
    import * as config from '@/config'

    import debounce from 'tiny-debounce'

    export default {
        props: ['value'],
        data () {
            return {
                keyword: '',
                inputKeyword: '',
                flatIssues: [],
                treeIssues: [],
                isLoading: false,
                isInitted: false,
                selectedIssues: [],
                types: []
            }
        },
        computed: {
            selections() {
                const selections = []

                for (const selected of this.selectedIssues) {
                    const issue = this.flatIssues.find((issue) => {
                        return issue.id === selected.id
                    })
                    if (issue) {
                        if (issue.id > 0) {
                            selections.push(issue)
                        }
                    }
                }
                return selections
            }
        },
        methods: {
            initComponent ()
            {
                var selectedIssues = []

                if (this.isInitted) return

                if ((this.value.length) && (this.flatIssues.length)) {
                    this.isInitted = true

                    this.value.forEach((value) => {
                        var issues = this.flatIssues.filter(function(item) {
                            return value.id === item.id
                        })
                        if (issues.length) {
                            selectedIssues.push(issues[0])
                        }
                    })

                    this.selectedIssues = selectedIssues
                }
            },
            fetchIssues() {
                this.loading = true

                return fetch(config.BASE_URL + '/issue/tree/all', {
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': 'Bearer ' + localStorage.getItem('token')
                        },
                    })
                    .then(res => res.json())
                    .then((data) => {
                        data.data.issueList.forEach((issue, index) => {
                            this.flatIssues = this.flatIssues.concat(issue)
                            if (issue.treeChilds.length) {
                                this.flatIssues = this.flatIssues.concat(issue.treeChilds)

                                var treeChilds = issue.treeChilds
                                treeChilds.unshift({
                                        deletedAt: null,
                                        id: issue.id,
                                        onlyAdminUsed: issue.onlyAdminUsed,
                                        title: issue.title,
                                        treeChilds: []
                                    })

                                this.treeIssues.push({
                                    deletedAt: null,
                                    id: (-1 * issue.id),
                                    onlyAdminUsed: issue.onlyAdminUsed,
                                    title: issue.title,
                                    treeChilds: treeChilds
                                })
                            } else {
                                this.treeIssues.push(issue)
                            }
                        })

                        this.loading = false
                    })
                    .catch(err => console.log(err))
            }
        },
        created () {
            this.fetchIssues()
        },
        mounted() {
            this.$nextTick(this.initComponent)
        },
        watch: {
            inputKeyword: debounce(function (newVal) {
                this.keyword = newVal
            }, 1000),
            treeIssues (val)
            {
                this.flatIssues = []

                this.treeIssues.forEach((issue, index) => {
                    if (issue.treeChilds.length) {
                        this.flatIssues = this.flatIssues.concat(issue.treeChilds)
                    } else {
                        this.flatIssues.push(issue)
                    }
                })
                this.initComponent()
            },
            selectedIssues (value) 
            {
                this.$emit('input', this.selections)
            },
            value (newValue) 
            {
                if (!this.isInitted) {
                    this.initComponent()
                }
            }
        },
    }
</script>

<style lang="scss">
    .treeview-container {
        height: 62.5vh;
        overflow: auto;
    }
</style>